
import { createApp } from 'vue/dist/vue.esm-bundler'
import ProductFinder from '../vue/ProductFinder.vue'

function setup(el) {

    createApp({
        data: () => {
            return {
                app: JSON.parse(el.dataset.app)
            }
        },
        components: {
            'productfinder': ProductFinder
        }
    }).mount(el)
}

function init() {

    const el = document.querySelector('.product-finder')
    if (!el) return

    setup(el)
}

init()
